import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import * as styles from "./Heading.css";
import clsx from "clsx";
import { sanitizeDisplayText } from "~/utils";

export type HeadingProps = ComponentPropsWithoutRef<"div"> &
  styles.HeadingVariants &
  PropsWithChildren & {
    as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span";
    bold?: boolean;
  };

export const Heading = ({
  size = "h1",
  children,
  as = "h1",
  uppercase = false,
  bold = false,
  className,
  ...props
}: HeadingProps) => {
  const Component = as;

  return (
    <Component
      className={clsx(
        className,
        styles.heading({ size: size, uppercase: uppercase, bold: bold }),
      )}
      {...props}
    >
      {(typeof children === "string" || typeof children === "number") &&
        children}
    </Component>
  );
};
